import React from 'react'


const LabelDetail = props => {
    let { title, description } = props

    title = title === 'null' ? '' : title
    description = description === 'null' ? '' : description

    return (
        <div className='label-detail'>
            <p className='title'>{title}</p>
            <p className='description'>{description}</p>
        </div>
    )
}

export default LabelDetail


// WEBPACK FOOTER //
// ./src/acervo/components/UI/Label/LabelDetail.js